import { gql } from 'apollo-angular';
import { EventSubscription } from '../../entities/events/event';

export const UPDATE_EVENT_SUBSCRIPTION_MUTATION = gql`
mutation updateEventSubscription($input: EventSubscriptionInput) {
  updateEventSubscription(input: $input) {
    id
  }
}
`;

export const CREATE_EVENT_SUBSCRIPTION_MUTATION = gql`
mutation createEventSubscription($input: EventSubscriptionInput) {
  createEventSubscription(input: $input) {
    id
  }
}
`;

export const DELETE_EVENT_SUBSCRIPTION_MUTATION = gql`
mutation deleteTimeEntry($id: UUID) {
  deleteEventSubscription(id: $id)
}
`;

export const SEND_TEST_EVENT_MUTATION = gql`
mutation sendTestEvent($id: UUID, $entityId: UUID, $eventType: String, $jsonData: Map) {
  sendTestEvent(id: $id, entityId: $entityId, eventType: $eventType, jsonData: $jsonData)
}
`;

export const UPDATE_EVENT_SUBSCRIPTION_SECRET_MUTATION = gql`
mutation updateEventSubscriptionSecret($id: UUID, $secret: String) {
  updateEventSubscriptionSecret(id: $id, secret: $secret)
}
`;

export const DELETE_EVENT_SUBSCRIPTION_SECRET_MUTATION = gql`
mutation deleteEventSubscriptionSecret($id: UUID) {
  deleteEventSubscriptionSecret(id: $id)
}
`;

export const EVENT_SUBSCRIPTION_BY_ID_QUERY = gql`
query eventSubscriptionByIdQuery($id: UUID!) {
  eventSubscription: getEventSubscription(id: $id) {
    id
    externalId
    url
    eventTypes
    lastTriggeredDateTime
    active
    type
    customHtmlHeaders
    secretHash
  }
}
`;

export interface EventSubscriptionByIdQueryResponse {
  loading: boolean;
  eventSubscription: EventSubscription;
}
